/**
 * 🎯 Platform-aware Quest Video Capture
 * 
 * Lädt automatisch die richtige Komponente:
 * - Web/Browser → QuestVideoCapture (Screenshot-basiert)
 * - Android/Quest → QuestVideoCaptureNative (Native Kamera)
 * 
 * Android-App bleibt unverändert funktionsfähig!
 */

// Web-Build verwendet immer QuestVideoCapture
import QuestVideoCapture from './QuestVideoCapture';

console.log('[Quest Platform] ✅ Lade Web-Komponente (QuestVideoCapture)');

export default QuestVideoCapture;
